<template>
  <div style="padding: 0 !important; height: 100% !important;">
    <v-container class="onboard-container" fluid>
      <v-row style="height: 100% !important;">
        <!-- Steps Data !-->
        <v-col class="left-pane" cols="7">
          <v-row style="height: 10%" align="center">
            <div>
              <p class="brought-to-you my-0">{{ $t('broughtToYou') }}</p>
              <v-img :src="partnerImage" contain position="left" max-width="100"/>
            </div>
          </v-row>
          <v-row style="height: 80%" align="center">
            <div>
              <v-form v-if="step === 1" v-model="validBasic">
                <h2>{{ $t('steps.1.headOne') }}</h2>
                <h1>{{ $t('steps.1.headTwo') }}</h1>
                <v-spacer class="my-5"/>
                <v-text-field class="basic-element" :label="$t('form.firstName.label')"
                              :rules="firstNameRules" v-model="firstName" outlined/>
                <v-text-field class="basic-element" :label="$t('form.lastName.label')"
                              :rules="lastNameRules" v-model="lastName" outlined/>
                <v-text-field class="basic-element" :label="$t('form.username.label')"
                              :rules="usernameRules" v-model="username" outlined/>
              </v-form>
              <v-form v-if="step === 2" v-model="validExperience">
                <h2>{{ $t('steps.2.headOne') }}</h2>
                <h1>{{ $t('steps.2.headTwo') }}</h1>
                <v-spacer class="my-5"/>
                <v-autocomplete class="basic-element" :items="countries"
                                :label="$t('form.country.label')" :rules="countryRules" v-model="country" item-text="name" item-value="name" outlined/>
                <v-select class="basic-element" :items="traderTypes" item-text="text" item-value="value"
                          :label="$t('form.typeOfTrading.label')" :rules="typeOfTradingRules" v-model="traderType" outlined/>
                <v-select class="basic-element" :items="experiences" item-text="text" item-value="value"
                          :label="$t('form.experience.label')" :rules="experienceRules" v-model="traderExperience" outlined/>
              </v-form>
              <v-form v-if="step === 3" v-model="validSync">
                <h2>{{ $t('steps.3.headOne') }}</h2>
                 <h1>{{ $t('steps.3.headTwo', {partnerShortName: $store.state.whitelabel.partner.shortName}) }}</h1>
                <v-chip class="my-1" color="calmGreen"><p class="chip-text" v-html="$t('steps.3.chip')"/></v-chip>
                <v-spacer class="my-10"/>
                <div class="d-flex align-start justify-start">
                  <v-select class="basic-element" :items="mtServers" item-text="name" item-value="value" return-object
                            :label="$t('form.mtServer.label', {partnerShortName:$store.state.whitelabel.partner.shortName})" :rules="mtServerRules" v-model="mtServer" outlined/>
                  <v-icon class="icon mt-4" color="primary" small @click="findOutSomething('mtServer')">fa-circle-info</v-icon>
                </div>
                <div class="d-flex align-start justify-start">
                  <v-text-field class="basic-element" :label="$t('form.mtLogin.label')"
                                :rules="mtLoginRules" v-model="mtLogin" outlined/>
                  <v-icon class="icon mt-4" color="primary" small @click="findOutSomething('mtLogin')">fa-circle-info</v-icon>
                </div>
                <div v-if="showInvestorPasswordField" class="d-flex align-start justify-start">
                  <v-text-field class="basic-element" :label="$t('form.mtInvestorPassword.label')"
                                :rules="mtInvestorPasswordRules" v-model="mtInvestorPassword" outlined/>
                  <v-icon class="icon mt-4" color="primary" small @click="findOutSomething('mtInvestorPassword')">fa-circle-info</v-icon>
                </div>
              </v-form>
              <v-btn v-if="step === 2" class="back-button mr-3 mt-3" @click="goBack">{{ $t(`steps.${step}.btnBack`) }}</v-btn>
              <v-btn class="submit-button mt-3" @click="goContinue">{{ $t(`steps.${step}.btnContinue`) }}</v-btn>
            </div>
          </v-row>
          <v-row style="height: 10%" align="end">
            <v-progress-circular color="calmGreen" :value="step * 34"/>
            <p class="ml-3 my-1" v-html="$t('stepProgress', { current: step, total: 3 })"/>
          </v-row>
        </v-col>

        <!-- Steps Animation !-->
        <v-col class="right-pane" cols="5">
          <v-row style="height: 100%" align="end" justify="center">
            <lottie :options="lottieOptions" :height="560"/>
          </v-row>
        </v-col>
      </v-row>

      <!-- More Explanation !-->
      <v-overlay v-model="overlayExplanation">
        <FindOutSomething :resource="explanationResource"
                          :title="explanationTitle"
                          :description="explanationDescription"
                          @close="overlayExplanation = false"/>
      </v-overlay>

      <!-- Sync Attempt !-->
      <v-overlay v-model="overlaySyncAttempt">
        <SyncAttempt :login="mtLogin" :server="mtServer.host" :investor-password="mtInvestorPassword"
                     :account-type="brokerAccountType" @close="overlaySyncAttempt = false"/>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import * as animationData from "@/assets/animations/onboard-astronaut.json";

import AuthRepository from '../../repositories/auth'
import PartnerRepository from '../../repositories/partner';
import BrokerAccountRepository from '../../repositories/brokerAccount'
import MetaTraderCredentialsRepository from '../../repositories/metaTraderCredentials'
import MetaTraderServerDetailsRepository from '../../repositories/metaTraderServerDetails'
import CognitoAuthRepository from "../../repositories/cognitoAuth"
import Countries from '../Register/countries';
import FindOutSomething from "@/components/FindOutSomething.vue";
import SyncAttempt from "@/views/Onboard/components/SyncAttempt.vue";
import { mapMutations } from "vuex";

export default {
  name: "OnboardIndex",
  components: {SyncAttempt, FindOutSomething},
  data() {
    return {
      lottieOptions: { animationData: animationData.default, },
      partnerImage: this.$store.state.whitelabel.partner.fullLogoUrl,
      countries: Countries,
      traderTypes: [
        { text: 'Swing Trader', value: 'Swing Trader' },
        { text: 'Day Trader', value: 'Day Trader' },
        { text: 'Core Trader', value: 'Core Trader' },
        { text: this.$t('categories.traderTypes.highFrequencyTrader'), value: 'High-Frecuency Trader' },
        { text: this.$t('categories.traderTypes.iDontKnow'), value: 'I don\'t know' },
      ],
      experiences: [
        { text: this.$t('categories.experiences.learning'), value: 'LEARNING' },
        { text: this.$t('categories.experiences.demo'), value: 'TRADING_DEMO' },
        { text: this.$t('categories.experiences.realNoProfit'), value: 'TRADING_REAL_WITHOUT_PROFIT' },
        { text: this.$t('categories.experiences.profitSixMonths'), value: 'PROFIT_LESS_6_MONTHS' },
        { text: this.$t('categories.experiences.profitConsistent'), value: 'PROFIT_MORE_6_MONTHS' },
      ],
      mtServers: [],

      step: 1,
      firstName: '',
      lastName: '',
      username: '',
      country: '',
      traderType: '',
      traderExperience: '',
      mtServer: {},
      mtLogin: '',
      mtInvestorPassword: '',
      brokerAccountType: '',

      // Validations
      validBasic: false,
      firstNameRules: [
        p => !!p || this.$t('form.firstName.mandatory'),
      ],
      lastNameRules: [
        p => !!p || this.$t('form.lastName.mandatory'),
      ],
      usernameRules: [
        u => !!u || this.$t('form.username.mandatory'),
        u => (u || '').length < 35 || this.$t('form.username.maxLength'),
        u => !u.includes('@') || this.$t('form.username.not1'),
        u => !u.includes('&') || this.$t('form.username.not2'),
        u => (u.split(' ').length <= 1) || this.$t('form.username.not3'),
      ],
      countryRules: [
        c => !!c || this.$t('form.country.mandatory'),
      ],
      typeOfTradingRules: [
        t => !!t || this.$t('form.typeOfTrading.mandatory'),
      ],
      experienceRules: [
        e => !!e || this.$t('form.experience.mandatory'),
      ],
      mtServerRules: [
        mts => !!mts || this.$t('form.mtServer.mandatory'),
      ],
      mtLoginRules: [
        mtl => !!mtl || this.$t('form.mtLogin.mandatory'),
      ],
      mtInvestorPasswordRules: [
        mtl => !!mtl || this.$t('form.mtInvestorPassword.mandatory'),
      ],

      validExperience: false,
      validSync: false,

      // Explanation
      overlayExplanation: false,
      explanationResource: '',
      explanationTitle: '',
      explanationDescription: '',

      // Sync Attempt
      overlaySyncAttempt: false,

      // Investor password
      showInvestorPasswordField: this.$store.state.whitelabel.isInvestorPasswordRequired,
    }
  },
  watch: {
    mtServer() {
      this.brokerAccountType = this.mtServers.find((s) => s.name === this.mtServer.name).type;
    }
  },
  async mounted() {
    /* eslint-disable no-console */
    this.mtServers = (await MetaTraderServerDetailsRepository.getMetaTraderServersByPartner(this.$store.state.whitelabel.partner.id)).data
    let logged = this.$store.state.token !== ''
    if(logged) { // Comes from the passwordless checking or the embedIndex embed after being logged
      let brokerAccountsByPartner = (await BrokerAccountRepository.allBrokerAccountsOfUser()).data
      if(brokerAccountsByPartner.length > 0) { // User already has broker accounts with partner!
        // Go to dashboard babe
        await this.$router.push('/dashboard');
      }else{
        let usageState = this.$store.state.user.details.usageState
        if(usageState === 'PRE_REGISTERED'){
          // Go to step 2 to continue onboarding
          this.step = 2
        } else { // otherwise we force the user to insert an account
          this.step = 3
        }
      }
    } else { // if currentUser is not defined, It is a new user, does not have account on swiset, proceed normally from step 1
      this.step = 1 
    }
    /* eslint-enable no-console */
  },
  methods: {
    goContinue() {
      switch (this.step) {
        case 1:
          this.validateAndCollapsedRegisterUser();
          break;
        case 2:
          this.completeUserAndExperienceData();
          break;
        case 3:
          this.connectMetaTrader();
          break;
      }
    },
    goBack() {
      this.step--;
    },
    findOutSomething(goal) {
      this.overlayExplanation = true;
      switch (goal) {
        case 'mtServer':
          this.explanationResource = 'https://swiset.com/wp-content/uploads/2023/06/Swiset-MT-Server-Hint.png';
          this.explanationTitle = this.$t(`form.${goal}.explanation.title`);
          this.explanationDescription = this.$t(`form.${goal}.explanation.description`);
          break;
        case 'mtLogin':
          this.explanationResource = 'https://swiset.com/wp-content/uploads/2023/06/Swiset-MT-Login-Hint.png';
          this.explanationTitle = this.$t(`form.${goal}.explanation.title`);
          this.explanationDescription = this.$t(`form.${goal}.explanation.description`);
          break;
        case 'mtInvestorPassword':
          this.explanationResource = 'https://swiset.com/wp-content/uploads/2023/06/Swiset-MT-Server-Hint.png';
          this.explanationTitle = this.$t(`form.${goal}.explanation.title`);
          this.explanationDescription = this.$t(`form.${goal}.explanation.description`);
          break;
      }
    },
    ...mapMutations(['setUser']),
    async validateAndCollapsedRegisterUser() {
      if(this.validBasic) {
        const username = (await AuthRepository.getUsernameFromEmail(this.$store.state.whitelabel.userEmail)).data
        if(username) {
          this.$router.push({name: 'passwordless-checking'})
        } else {
          AuthRepository.existingUsernameOrEmail(this.username, this.$store.state.whitelabel.userEmail).then(async (response) => {
            if (response.status < 400) {
              let data = response.data;
              if (data === -1) {
                const randomString = (n) => [...Array(n)].map(() => {
                  const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                  return charSet.charAt(Math.floor(Math.random() * charSet.length));
                }).join('');
                let userData = {
                  email: this.$store.state.whitelabel.userEmail,
                  firstName: this.firstName,
                  lastName: this.lastName,
                  username: this.username,
                  password: randomString(30),
                  activate: true
                }
                await AuthRepository.registerCollapsedUser(userData).then(async (res) => {
                  let user = res.data
                  this.setUser(user)
                  let email = this.$store.state.whitelabel.userEmail
                  const result = await CognitoAuthRepository.createCognitoAuthFromSwisetUser(email,email)
                  if(!result) {
                    alert("Failed registration to Authprovider from existing user")
                  }else{
                    this.$router.push({name: 'passwordless-checking'})
                  }
                })
              }
              else alert(this.$t('form.username.existingIssue'));
            }
          });
        }
      }
      else alert(this.$t('formIssue'));
    },
    ...mapMutations(['setCompletedRegister']),
    completeUserAndExperienceData() {
      if(this.validExperience) {
        let userData = {
          userId: this.$store.state.user.id,
          firstName: this.$store.state.user.firstName,
          lastName: this.$store.state.user.lastName,
          username: this.$store.state.user.username,
          phoneNumber: '', // Think later
          country: this.country,
          typeOfTrader: this.traderType,
          previousExperience: this.traderExperience,
          channel: 'Whitelabel',
        };

        AuthRepository.completeUserRegister(userData).then( async (response) => {
          if (response.status < 400 && response.data) {
            this.setCompletedRegister(userData);
            window.sendinblue.identify(this.$store.state.user.email, {
              'NOMBRE': this.$store.state.user.firstName,
              'SURNAME': this.$store.state.user.lastName,
              'USERNAME': this.$store.state.user.username,
              'PHONE': '',
              'COUNTRY': this.country,
              'PRO_ON': '0',
              'LANG': this.$i18n.locale,
              'CHANNEL': 'Whitelabel',
            });
            window.sendinblue.track('fullRegister');
            window.fbq('track', 'CompleteRegistration');
            this.step = 3
          }
        });
      }
      else alert(this.$t('formIssue'));
    },
    ...mapMutations(['setIsPro']),
    connectMetaTrader() {
      /* eslint-disable no-console */
      if(this.validSync) {
        this.overlaySyncAttempt = true;
        let metatraderCredentialsFromPartner = {
          server: this.mtServer.host,
          serverName: this.mtServer.name,
          login: this.mtLogin,
          investorPassword: this.mtInvestorPassword,
          partnerId: this.$store.state.whitelabel.partner.id,
          version: this.mtServer.version,
          platform: this.$store.state.whitelabel.platform.name
        }
        console.log(metatraderCredentialsFromPartner)
        MetaTraderCredentialsRepository.createCredentialsFromPartner(metatraderCredentialsFromPartner).then(async (res) => {
          if(res.status<400){
            await MetaTraderCredentialsRepository.updateAllTradesForMetaTraderCredential(res.data).then((response) => {
              if(response.status < 400)
                PartnerRepository.verifyProUpgradeByPartner(this.$store.state.whitelabel.partner.id);
            });
            await this.$router.push('/dashboard');
          }else{
            alert(this.$t('formIssue'));
            this.showInvestorPasswordField = true;
          }
          this.overlaySyncAttempt = false
        }).catch((err) => {
          console.log(err)
          alert(this.$t('formIssue'));
          this.showInvestorPasswordField = true;
          this.overlaySyncAttempt = false
        })
      } else {
        alert(this.$t('formIssue'));
      }
      /* eslint-enable no-console */
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/global";

.onboard-container {
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}

.left-pane {
  padding: 2.5% 4% 2.5% 5%;
}

.right-pane {
  padding: 0;
  background-color: $black-color;
  background-repeat: no-repeat;
  background-size: contain, cover;
  background-position: right;
}

.brought-to-you {
  color: $border-color;
}

.basic-element {
  max-width: 25vw;
}

.chip-text {
  margin-bottom: 0;
  color: #247851;
  font-size: 14px;
}
</style>

<i18n>
{
  "en": {
    "broughtToYou": "Brought to you by",
    "steps": {
      "1": {
        "headOne": "Just few seconds to",
        "headTwo": "fit your trader experience",
        "btnContinue": "Continue »"
      },
      "2": {
        "headOne": "Almost done to",
        "headTwo": "lift your trading to a top level",
        "btnBack": "« Back",
        "btnContinue": "Continue »"
      },
      "3": {
        "headOne": "Great!",
        "headTwo": "Connect & Sync your {partnerShortName} Account",
        "chip": "Trades will be automatically synced",
        "btnContinue": "Connect Account »"
      }
    },
    "categories": {
      "traderTypes": {
        "iDontKnow": "I don't know",
        "highFrequencyTrader": "High-Frequency Trader"
      },
      "experiences": {
        "learning": "Just learning trading",
        "demo": "Trading on demo",
        "realNoProfit": "Trading on real without profit",
        "profitSixMonths": "Profitable on real less than 6 months",
        "profitConsistent": "Profitable on real more than 6 months"
      }
    },
    "form": {
      "firstName": {
        "label": "What’s your first name?",
        "mandatory": "First name is required"
      },
      "lastName": {
        "label": "What’s your last name?",
        "mandatory": "Last name is required"
      },
      "username": {
        "label": "Create a username",
        "mandatory": "Username is required",
        "maxLength": "Username should have less than 35 characters.",
        "not1": "Not '@' allowed",
        "not2": "Not & allowed",
        "not3": "Not spaces allowed",
        "existingIssue": "Username already exists.\nPlease try with another one."
      },
      "country": {
        "label": "Where do you live?",
        "mandatory": "Country is mandatory"
      },
      "typeOfTrading": {
        "label": "What’s your favorite type of trading?",
        "mandatory": "Trading style is mandatory"
      },
      "experience": {
        "label": "What’s your experience trading?",
        "mandatory": "Experience is mandatory"
      },
      "mtServer": {
        "label": "Select your {partnerShortName} MT4 Server",
        "mandatory": "MetaTrader server is mandatory",
        "explanation": {
          "title": "How to find out your<br>{partnerShortName} MT4 Server?",
          "description": "Over your Navigator > YourBrokerName > Accounts"
        }
      },
      "mtLogin": {
        "label": "Write your Account Login",
        "mandatory": "MetaTrader login is mandatory",
        "explanation": {
          "title": "How to find out your<br>MT4 Account Login?",
          "description": "Over your Navigator > YourBrokerName > Accounts"
        }
      },
      "mtInvestorPassword": {
        "label": "Write your Account Investor Password",
        "mandatory": "Investor password is mandatory",
        "explanation": {
          "title": "How to find out your<br>MT4 Investor Password?",
          "description": "Click on Tools > Options > Server > Change Password > Change Investor (read only) password."
        }
      }
    },
    "formIssue": "Error with your data.\nPlease review each field.",
    "commonIssue": "An error occurred.\nTry again.",
    "stepProgress": "<b>Step {current}</b> from {total}"
  },
  "es": {
    "broughtToYou": "Traído a ti por",
    "steps": {
      "1": {
        "headOne": "Pocos segundos para",
        "headTwo": "personalizar tu experiencia de trader",
        "btnContinue": "Continuar »"
      },
      "2": {
        "headOne": "Casi listo para",
        "headTwo": "elevar tu trading a nivel top",
        "btnBack": "« Atrás",
        "btnContinue": "Continuar »"
      },
      "3": {
        "headOne": "¡Genial!",
        "headTwo": "Conecta & Sincroniza tu cuenta {partnerShortName}",
        "chip": "Trades serán automáticamente sincronizados",
        "btnContinue": "Conectar Cuenta »"
      }
    },
    "categories": {
      "traderTypes": {
        "iDontKnow": "No lo sé",
        "highFrequencyTrader": "Trader de Alta-Frecuencia"
      },
      "experiences": {
        "learning": "Sólo aprendiendo de trading",
        "demo": "Trading en demo",
        "realNoProfit": "Trading en real sin beneficio",
        "profitSixMonths": "Rentable en real por menos de 6 meses",
        "profitConsistent": "Rentable en real por más de 6 meses"
      }
    },
    "form": {
      "firstName": {
        "label": "¿Cuál es tu nombre?",
        "mandatory": "Nombre es obligatorio"
      },
      "lastName": {
        "label": "¿Cuál es tu apellido?",
        "mandatory": "Apellido es obligatorio"
      },
      "username": {
        "label": "Crea un nombre de usuario",
        "mandatory": "Nombre de usuario es obligatorio",
        "maxLength": "Nombre de usuario debe tener máximo 35 caracteres.",
        "not1": "No '@' permitidos",
        "not2": "No & permitidos",
        "not3": "No espacios permitidos",
        "existingIssue": "Nombre de usuario ya existe.\nPor favor intenta con otro."
      },
      "country": {
        "label": "¿Dónde vives?",
        "mandatory": "País es obligatorio"
      },
      "typeOfTrading": {
        "label": "¿Cúal es tu estilo de trading favorito?",
        "mandatory": "Estilo de trading es obligatorio"
      },
      "experience": {
        "label": "¿Cuál es tu experiencia en el trading?",
        "mandatory": "Experiencia es obligatoria"
      },
      "mtServer": {
        "label": "Selecciona tu Servidor {partnerShortName} MT4",
        "mandatory": "Servidor MetaTrader es obligatorio",
        "explanation": {
          "title": "¿Cómo encontrar tu<br>Servidor MT4 de {partnerShortName}?",
          "description": "Sobre Navegador  > YourBrokerName > Cuentas"
        }
      },
      "mtLogin": {
        "label": "Escribe tu Login de Cuenta",
        "mandatory": "Cuenta MetaTrader es obligatoria",
        "explanation": {
          "title": "¿Cómo encontrar tu<br>Login de Cuenta MT4?",
          "description": "Sobre Navegador > YourBrokerName > Cuentas"
        }
      },
      "mtInvestorPassword": {
        "label": "Escribe tu Contraseña de Inversionista",
        "mandatory": "Contraseña de Inversionista es obligatoria",
        "explanation": {
          "title": "¿Cómo encontrar tu<br>Contraseña de Inversionista MT4?",
          "description": "Click en Herramientas > Opciones > Servidor > Cambiar Contraseña > Cambiar contraseña (sólo lectura) de inversionista."
        }
      }
    },
    "formIssue": "Error con tu información.\nPor favor revisa cada campo.",
    "commonIssue": "Ocurrió un error.\nIntenta de nuevo.",
    "stepProgress": "<b>Paso {current}</b> de {total}"
  }
}
</i18n>